module.exports = __webpack_public_path__ + "static/media/newbanner1.81609a82.webp";